import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Slider } from "primereact/slider";
import { FloatLabel } from "primereact/floatlabel";
import { WeekPicker } from "./WeekPicker";

interface WeekRangeModalProps {
  visible: boolean;
  onHide: () => void;
  onApply: (
    startWeek: number,
    startYear: number,
    numberOfWeeks: number
  ) => void;

  // Current values
  currentStartWeek: number;
  currentStartYear: number;
  currentNumberOfWeeks: number;
}

export const WeekRangeModal: React.FC<WeekRangeModalProps> = ({
  visible,
  onHide,
  onApply,
  currentStartWeek,
  currentStartYear,
  currentNumberOfWeeks,
}) => {
  const [startWeek, setStartWeek] = useState<number>(currentStartWeek);
  const [startYear, setStartYear] = useState<number>(currentStartYear);
  const [numberOfWeeks, setNumberOfWeeks] =
    useState<number>(currentNumberOfWeeks);

  // Reset form when modal opens
  useEffect(() => {
    if (visible) {
      setStartWeek(currentStartWeek);
      setStartYear(currentStartYear);
      setNumberOfWeeks(currentNumberOfWeeks);
    }
  }, [visible, currentStartWeek, currentStartYear, currentNumberOfWeeks]);

  const handleApply = () => {
    onApply(startWeek, startYear, numberOfWeeks);
    onHide();
  };

  return (
    <Dialog
      header="Set Week Range"
      visible={visible}
      style={{ width: "450px" }}
      onHide={onHide}
      resizable={false}
      footer={
        <div className="flex justify-content-end gap-2">
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-outlined"
            onClick={onHide}
          />
          <Button label="Apply" icon="pi pi-check" onClick={handleApply} />
        </div>
      }
      closable={true}
      modal={true}
    >
      <div className="grid">
        {/* Start Week Selection */}
        <div className="col-12">
          <div className="field">
            <FloatLabel>
              <WeekPicker
                value={startWeek}
                year={startYear}
                onChange={(week, selectedYear) => {
                  setStartWeek(week);
                  setStartYear(selectedYear);
                }}
              />
              <label className="block text-sm font-medium">Start Week</label>
            </FloatLabel>
          </div>
        </div>

        {/* Number of Weeks Slider */}
        <div className="col-12">
          <div className="field">
            <label className="block text-sm font-medium mb-2">
              Number of Weeks: {numberOfWeeks}
            </label>
            <div className="flex align-items-center gap-3">
              <span className="text-sm">1</span>
              <Slider
                value={numberOfWeeks}
                onChange={(e) =>
                  setNumberOfWeeks(
                    Array.isArray(e.value) ? e.value[0] : e.value
                  )
                }
                min={1}
                max={52}
                step={1}
                className="flex-1"
              />
              <span className="text-sm">52</span>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
